"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_script_1 = require("./use-script");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return use_script_1.default; } });
//# sourceMappingURL=index.js.map